import { useDiffComputation } from '@/hooks/use-diff-computation'

export interface UnifiedDiffViewProps {
  original: string
  proposed: string
  filename?: string
  className?: string
  showLineNumbers?: boolean
  maxHeight?: string
}

/**
 * Unified diff view component that displays line-by-line changes.
 * Extracted from DiffPreviewDialog for reuse in document pane.
 */
export function UnifiedDiffView({
  original,
  proposed,
  filename = 'document.md',
  className = '',
  showLineNumbers = true,
  maxHeight
}: UnifiedDiffViewProps) {
  const { changes } = useDiffComputation(original, proposed, filename)

  return (
    <div 
      className={`p-4 space-y-0 ${className}`}
      style={maxHeight ? { maxHeight, overflow: 'auto' } : undefined}
    >
      {changes.map((change, idx) => {
        // Split change into lines for better display
        const lines = change.value.split('\n')
        return lines.map((line, lineIdx) => (
          <div
            key={`${idx}-${lineIdx}`}
            className={`font-mono text-sm py-0.5 px-2 border-l-2 ${
              change.added ? 'bg-green-100 dark:bg-green-950/30 text-green-900 dark:text-green-300 border-green-500' :
              change.removed ? 'bg-red-100 dark:bg-red-950/30 text-red-900 dark:text-red-300 border-red-500' :
              'border-transparent'
            }`}
          >
            <span className="select-none inline-block w-4 text-muted-foreground mr-2">
              {change.added ? '+' : change.removed ? '-' : ' '}
            </span>
            <span className="whitespace-pre-wrap break-words">{line || ' '}</span>
          </div>
        ))
      })}
    </div>
  )
}

